export default {
  base: {
    fontFamily: 'link',
    focus: {
      backgroundColor: 'primary-yellow-100'
    }
  }
};